import { Link } from "react-router-dom";
import { Phone, MessageCircle, Clock } from "lucide-react";
import { LogoLockup } from "./Logo";
import { SERVICES } from "../data/services";
import { LOCATIONS } from "../data/locations";
import { PHONE_TEL, PHONE_DISPLAY, waLink, DEFAULT_WA_MSG } from "../data/site";

export default function Footer() {
  return (
    <footer className="border-t border-[#27272A] bg-[#0B0B0C]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <LogoLockup />
            <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-xs">
              24/7 mobile tyre fitting, puncture repair and wheel alignment
              across six UK regions. One call and the workshop comes to you.
            </p>
            <p className="mt-5 flex items-center gap-2 font-telemetry text-xs uppercase tracking-[0.2em] text-emerald-400">
              <Clock className="w-4 h-4" /> Open 24 hours · 7 days
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="font-telemetry text-[10px] uppercase tracking-[0.3em] text-[#FF5500] mb-4">
              Services
            </p>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-zinc-400 hover:text-white transition-colors"
                  >
                    {s.shortName}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-telemetry text-[10px] uppercase tracking-[0.3em] text-[#FF5500] mb-4">
              Areas covered
            </p>
            <ul className="grid grid-cols-2 gap-2.5">
              {LOCATIONS.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/areas/${l.slug}`}
                    data-testid={`footer-location-${l.slug}`}
                    className="text-sm text-zinc-400 hover:text-white transition-colors"
                  >
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-telemetry text-[10px] uppercase tracking-[0.3em] text-[#FF5500] mb-4">
              Get on the road
            </p>
            <div className="space-y-3">
              <a
                href={PHONE_TEL}
                data-testid="footer-call-button"
                className="btn-glow flex items-center justify-center gap-2 w-full py-3.5 rounded-full bg-[#FF5500] text-black font-telemetry text-xs font-semibold uppercase tracking-[0.15em]"
              >
                <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
              </a>
              <a
                href={waLink(DEFAULT_WA_MSG)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-button"
                className="flex items-center justify-center gap-2 w-full py-3.5 rounded-full border border-emerald-500/60 text-emerald-400 hover:bg-emerald-500 hover:text-black transition-colors font-telemetry text-xs uppercase tracking-[0.15em]"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp us
              </a>
            </div>
          </div>
        </div>

        <div className="rule-dashed my-10" />
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-telemetry text-[11px] text-zinc-500 tracking-wider">
            © {new Date().getFullYear()} Motion Tyres Services. All rights reserved.
          </p>
          <p className="font-telemetry text-[11px] text-zinc-500 tracking-wider uppercase">
            12 UK regions · 24/7 mobile tyre fitting
          </p>
        </div>
      </div>
    </footer>
  );
}
